import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from './Components/Nav';
import Home from './Pages/Home';
import Product from './Pages/Products'; // Corrected import
import Contact from './Pages/Contact';
import Cart from './Pages/Cart';
import Footer from './Components/Footer';
import Dashboard from './Components/dashboard/Dashboard'; 
import ProductDetail from './Components/Products/ProductDetail'; // Adjusted path
import Addresses from './Components/dashboard/Addresses'; 
import Wallet from './Components/dashboard/Wallet'; 
import PaymentMethods from './Components/dashboard/PaymentMethods'; 
import ShippingAddress from './Components/dashboard/ShippingAddress'; 
import BillingAddress from './Components/dashboard/BillingAddress'; 
import Orders from './Components/dashboard/Orders'; 
import WithdrawPage from './Components/dashboard/WithdrawPage'; 
import EditProfile from './Components/dashboard/EditProfile'; 
import DashSidebar from './Components/dashboard/Sidebar'; 
import ReferralTree from './Components/dashboard/Tree';
import VendorSignup from './Components/Vendor/VendorSignup';
import VendorDashboard from './Components/Vendor/VendorDashboard';
import AddNewProduct from './Components/Vendor/AddNewProduct';
import VendorProducts from './Components/Vendor/VendorProducts';
import OrderList from './Components/Vendor/OrderList';
import VendorProfile from './Components/Vendor/VendorProfile';
import VendorVerifyProfile from './Components/Vendor/VendorVerifyProfile';
import AdminProfile from './Components/AdminPanel/AdminProfile';
import ProductListAdmin from './Components/AdminPanel/ProductListAdmin';
import SidebarAdmin from './Components/AdminPanel/SidebarAdmin';
import VendorListAdmin from './Components/AdminPanel/VendorListAdmin';
import UserListAdmin from './Components/AdminPanel/UserListAdmin';
import ProductList from './Components/Products/ProductList';
import Checkout from './Pages/Checkout';
import LoginPage from './Pages/LoginPage';
import Signup from './Pages/SignUp';
import AdminOrderPage from './Components/AdminPanel/AdminOrderPage';
import UserProfile from './Components/dashboard/UserProfile';
import './App.css';
import AboutUs from './Pages/AboutUs';
import AboutUsWelcome from './Components/AboutUs/AboutUsWelcome';
import MaintenancePage from './Components/MaintenancePage';

const categories = [
  { id: 1, name: 'Category 1' },
  { id: 2, name: 'Category 2' },
  // Add more categories as needed
];

const sizes = ['Small', 'Medium', 'Large'];
const colors = ['Red', 'Blue', 'Green'];
const materials = ['Cotton', 'Polyester', 'Wool'];

// Sample products data
const products = [
  { id: 1, name: 'Product 1', description: 'Description 1', price: 10 },
  { id: 2, name: 'Product 2', description: 'Description 2', price: 20 },
  // Add more products as needed
];
const userId = 'KRSM1306'; // Replace with the desired root user_id
const App = () => {
return <MaintenancePage />;
}
// return (
  //   <Router>
  //     <Navbar />
  //     <Routes>
  //       <Route path="/" element={<Home />} />
  //       <Route path="Products" element={<ProductList />} />
  //       <Route path="Contact" element={<Contact />} />
  //       <Route path="Cart" element={<Cart />} />
  //       <Route path="LoginPage" element={<LoginPage/>} />
  //       <Route path="Signup" element={<Signup/>} />

  //       <Route path="/dashboard/*" element={<Dashboard />} />
  //       <Route
  //         path="/products"
  //         element={
  //           <Product
  //             products={products}
  //             categories={categories}
  //             sizes={sizes}
  //             colors={colors}
  //             materials={materials}
  //           />
  //         }
  //       />
  //       <Route path="/products/:id" element={<ProductDetail />} />
  //       <Route path='Addresses' element={<Addresses/>}></Route>
  //       <Route path='Wallet' element={<Wallet/>}></Route>
  //       <Route path="PaymentMethods" element={<PaymentMethods/>}/>
  //       <Route path='ShippingAddress' element={<ShippingAddress/>}></Route>
  //       <Route path='BillingAddress' element={<BillingAddress/>}></Route>
  //       <Route path='Orders' element={<Orders/>}></Route>
  //       <Route path='WithdrawPage' element={<WithdrawPage/>}></Route>
  //       <Route path='EditProfile' element={<EditProfile/>}></Route>
  //       <Route path="Sidebar" element={<DashSidebar/>}/>
  //       <Route path="Tree" element={  <ReferralTree userId={userId} />}/>
  //       <Route path="VendorSignup" element={<VendorSignup/>}/>
  //       <Route path="VendorDashboard" element={<VendorDashboard/>}/>
  //       <Route path="AddNewProduct" element={<AddNewProduct/>}/>
  //       <Route path="VendorProducts" element={<VendorProducts/>}/>
  //       <Route path="VendorProfile" element={<VendorProfile/>}/>
  //       <Route path="VendorVerifyProfile" element={<VendorVerifyProfile/>}/>
  //       <Route path="OrderList" element={<OrderList/>}/>
  //       <Route path="DashboardAdmin" element={<AdminProfile/>}/>
  //       <Route path="AdminProfile" element={<AdminProfile/>}/>
  //       <Route path="SidebarAdmin" element={<SidebarAdmin/>}/>
  //       <Route path="UserListAdmin" element={<UserListAdmin/>}/>
  //       <Route path="VendorListAdmin" element={<VendorListAdmin/>}/>
  //       <Route path="ProductListAdmin" element={<ProductListAdmin/>}/>
  //       <Route path="checkout" element={<Checkout/>}/>
  //       <Route path="AdminOrderPage" element={<AdminOrderPage/>}/>
  //       <Route path="/admin/vendors" element={<VendorListAdmin />} />
  //       <Route path="/admin/vendor/:vendorId" element={<VendorProfile />} />
  //       <Route path="UserProfile" element={<UserProfile/>}/>
  //       <Route path="AboutUsWelcome" element={<AboutUsWelcome/>}/>
  //       <Route path="/AboutUs" element={<AboutUs/>}/>
       
  


  //     </Routes>
  //     <Footer />
  //   </Router>
  // );

export default App;
